import { Route, Routes } from "react-router-dom";

import ReceiptsPage from "../../src/modules/receipts/ReceiptsPage";

export const RECEIPTS_ROUTE = "receipts";

const ReceiptsRoutes = () => (
  <Routes>
    <Route index element={<ReceiptsPage />} />
  </Routes>
);

export default ReceiptsRoutes;
